export default __webpack_public_path__ + "static/media/change-numeric-field-dark.f38a6547.svg";